import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/live-agents_/$id/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$datasetSlug/settings/live-agents/$id/runs",
      params: { datasetSlug: params.datasetSlug, id: params.id },
    });
  },
});
